import { Injectable } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
//TODO This service exist purely to trigger menu opening from different components(where menu is)
//This is bad code, have to be removed when Menu is integrated as part of ModalController 
export class MenuStateService {
  
  public menuStateObservable: Subject<boolean> = new Subject();
  public menuSideObservable: Subject<string> = new Subject();
  
  constructor(private menuCtrl:MenuController) { 
    this.menuSideObservable = new ReplaySubject(1);
  }

  openSidemenu(menuSide?){
    if(menuSide){
      this.menuCtrl.open(menuSide);
      this.menuSideObservable.next(menuSide);
    }
  }
  
  isMenuOpen(menuSide) {
    return this.menuSideObservable;
  }

  setMenuOpenSide(menuSide){
    this.menuSideObservable.next(menuSide);
  }

  closeMenu(menuSide?) {
    if(menuSide){
      this.menuCtrl.close(menuSide);
    }
  }

}
